import { Typography } from '@mui/material'

import notifyAllImage from "./images/notify-all.png"
import synchroniseImage from "./images/synchronise.png"
import archiveImage from "./images/archive.png"

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Template details</Typography>
      <p>Here you can see details about your template.</p>
      <p>On the left you see similar information to what you saw in the template list, plus a few extra details.
        Some of the extras are unimportant, but might be of interest to you (eg. The Apple and Google pass types)
      </p>

      <Typography variant='h5' className='pt-10 pb-5'>Template preview</Typography>
      <p>On the right (or below if you have a narrow browser window) you'll see a preview of a sample issued pass
        in both Apple and Google formats. These are an as accurate represenation of what the passes will look like
        on actual Apple and Google devices as possible. They are very close, but not perfect, which is why you should
        always issue some test passes and view your passes on real devices before issuing live passes.</p>

      <Typography variant='h5' className='pt-10 pb-5'>Sub-menu</Typography>
      <p>Across the top you'll find some new menu items. You can find some help by clicking through to a new page
        and opening help there. There are four exceptions though where you do not go through to a new page:
      </p>
      <ul>
        <li><b>Notify All</b>: This opens a popup where you can write a message (notification). This message will be delivered to every
          installed pass created with this template. Use this for important announcement to every pass holder.
          eg. "Event postponed, new date will be posted shortly."<br /><br />
          <img src={notifyAllImage} style={{ border: "1px solid #999999" }} /></li>

        <li><b>Synchronise</b>: This opens a popup where you initiate synchronising passes. If there are no passes requiring
          synchronisation then the submit button will be greyed out.<br /><br />
          <img src={synchroniseImage} style={{ border: "1px solid #999999" }} /></li>

        <li><b>Archive/Unarchive</b>: This opens a popup where you can archive (or unarchive) a template<br /><br />
          <img src={archiveImage} style={{ border: "1px solid #999999" }} /></li>
      </ul>

      <Typography variant='h5' className='pt-10 pb-5'>Smartix Managed Template Passes</Typography>
      <p>If you are looking at a pass generated from a Smartix Managed Template, then you will see
        additional content below the main details. </p>

      <Typography variant='h6' className='pt-10 pb-5'>Event Tickets</Typography>
      <p>You can amend the event date/time here</p>

      <Typography variant='h6' className='pt-10 pb-5'>Stamp Cards & Loyalty Cards</Typography>
      <p>You can configure your signup form here and download PNG and SVG barcodes for your signup invites. </p>

    </div>
  )
}

export default HelpText